import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { BottomNavigation } from './BottomNavigation';

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Noise overlay */}
      <div className="noise-overlay" />

      <Header />

      <main className="flex-1 relative z-10">
        <div className="max-w-7xl mx-auto px-4 py-6 pb-24 md:pb-6">
          <Outlet />
        </div>
      </main>

      {/* Mobile bottom navigation */}
      <BottomNavigation />
    </div>
  );
}
